export function getBearerTokenFromHeaders(event: { headers?: Record<string, unknown> | null }): string | null {
    const h = event.headers as Record<string, string> | undefined;
    const auth = h?.['authorization'] ?? h?.['Authorization'];
    if (!auth || !auth.startsWith('Bearer ')) return null;
    return auth.slice(7).trim();
}

export const getToken = getBearerTokenFromHeaders;
